module.exports = __webpack_public_path__ + "img/wealth-management-finalist.b674f688.png";